// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type MenuCollapseIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from menu-collapse.svg
 */
export default function MenuCollapseIcon(props: MenuCollapseIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      data-component="MenuCollapseIcon"
      {...props}
    >
      <path
        fill="currentColor"
        d="m8.54 4.205 6.23 5.87a.69.69 0 0 1 0 1.03l-.72.68a.8.8 0 0 1-1.09 0L8 7.135l-4.96 4.65a.8.8 0 0 1-1.09 0l-.73-.69a.69.69 0 0 1 0-1.02l6.24-5.87a.8.8 0 0 1 1.08 0"
      />
    </svg>
  );
}
